// extracted by mini-css-extract-plugin
export var breadcrumb = "_18-2";
export var breadcrumbArrow = "_18-3";
export var breadcrumbs = "_18-0";
export var link = "_18-4";
export var small = "_18-1";